import { http } from '../../config/axios'

 const findConsulta = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/consulta/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findConsulta', error)
      throw Error(error.response.data)
    })
}

export default findConsulta;
